import { render, staticRenderFns } from "./ParlayTipsTable.vue?vue&type=template&id=5dcc91f7&scoped=true&"
import script from "./ParlayTipsTable.vue?vue&type=script&lang=js&"
export * from "./ParlayTipsTable.vue?vue&type=script&lang=js&"
import style0 from "./ParlayTipsTable.vue?vue&type=style&index=0&id=5dcc91f7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcc91f7",
  null
  
)

export default component.exports